import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import type { ValueOf } from 'cpool-utils';
import { LuCircleAlert, LuCircleCheck, LuCircleX, LuInfo } from 'react-icons/lu';

export const AlertState = {
    ERROR: 'error',
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
} as const;

export const AlertVariant = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
} as const;

export type AlertVariantType = ValueOf<typeof AlertVariant>;

export const stateConfig = {
    [AlertState.SUCCESS]: {
        bg: 'bg-alert-success-bg',
        border: 'border-alert-success',
        icon: LuCircleCheck,
        iconColor: 'text-alert-success',
    },
    [AlertState.INFO]: {
        bg: 'bg-surface-light',
        border: 'border-midnight',
        icon: LuInfo,
        iconColor: 'text-midnight',
    },
    [AlertState.WARNING]: {
        bg: 'bg-alert-warning-bg',
        border: 'border-alert-warning',
        icon: LuCircleAlert,
        iconColor: 'text-alert-warning',
    },
    [AlertState.ERROR]: {
        bg: 'bg-alert-error-bg',
        border: 'border-alert-error',
        icon: LuCircleX,
        iconColor: 'text-alert-error',
    },
} as const;

export const variantStyles = {
    [AlertVariant.PRIMARY]: 'border-l-2 border-t-0 border-r-0 border-b-0',
    [AlertVariant.SECONDARY]: 'border',
} as const;

export type AlertStateType = ValueOf<typeof AlertState>;

export interface AlertProps extends Omit<ComponentPropsWithoutRef<'div'>, 'title'> {
    state?: AlertStateType;
    variant?: AlertVariantType;
    title?: ReactNode;
    children?: ReactNode;
    hideIcon?: boolean;
}
